import React from 'react';
import { BCMSDate, DisabledPrompt, useBCMSContext, BCMSStateManagerCRUD, useStateManager, BCMSRecord, StateManager, useModel } from "bcms-react";
import Classes, { Account, OneTimeWireTransfer, WireHistory } from "model";
import { PageContainer, PageContentView } from 'components/shared';
import PendingWireWidget from './components/PendingWireWidget';
import ScheduledWiresWidget from './components/ScheduledWiresWidget';
import WireHistoryWidget from './components/WireHistoryWidget';
import ProcessedWireTemplatesWidget from './components/ProcessedWireTemplatesWidget';
import WireSearch from './components/WireHistoryWidget/classes/WireSearch';

import "./mobile.css";
import "./styles.css";

/**
 * @function WiresActivityPage
 * @return {React.Component}
 * @exported true
 * @description The page for wire activity
 */

export default function WiresActivityPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  // Branding options needed for captures
  const branding = useModel().branding.options;
  window.BRANDING = { 
      "wires_abi22" : branding.wires_abi22
  };

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
  });

  return(
    <PageContainer className="wires-activity-page" state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultData = () => ({
  pendingWireWidgetData: {
    // no data used for now.
    oneTimeWireTransfers: OneTimeWireTransfer.initAll().filter(item => item.status === "pending approval")
  },
  scheduledWiresWidgetData: {
    // no data used for now.
  },
  wireHistoryWidgetData: {
    accounts: Account.initAllAsset(),
    showSearchOptions: false,
    wireHistory: WireHistory.initAll(),
    search: WireSearch.init()
    //showSearchOptions: true,
    // Example of setting search values.
    //search: WireSearch.init({dateRange: "today"})
  }
});

// no ui changes for now
export const getDefaultUI = () => ({
  pendingWireWidgetUI: {
    
  },
  scheduledWiresWidgetUI: {
    
  },
  wireHistoryWidgetUI: {

  }
});

function PageContent(props) {
  const { data, ui } = useStateManager();

  return (
  <PageContentView>
    <div className="flex-container flex-vertical flex-width">
      <PendingWireWidget data={ data.pendingWireWidgetData } ui={ ui.pendingWireWidgetUI } />
      <ScheduledWiresWidget data={ data.scheduledWiresWidgetData } ui={ ui.scheduledWiresWidgetUI } />
      <WireHistoryWidget data={ data.wireHistoryWidgetData } ui={ ui.wireHistoryWidgetUI } />
      <ProcessedWireTemplatesWidget />
    </div>
  </PageContentView>
  );
}